import React from "react";
import { NavLink } from "react-router-dom";
import { doRequest } from "../../helper";
import PageTitle from "../PageTitle";
import $ from "jquery";
import moment from "moment";

class Count extends React.Component {
  constructor() {
    super();

    this.state = {
      itemscount: "",
      totalcount: "",
      items: [],
      disitems: [],
      response: null,
      postCount: 0,
      status: "Active",
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      startDate: "",
      endDate: "",
    };
  }

  componentDidMount() {
    this.getPosts();
    // setTimeout(() => {
    //   this.getPostsdis();
    // }, 200);
    // getPosts();
  }

  // getPostsdis = (status, loadmore) => {
  //   $("#loader").css({ display: "block" });
  //   var ref = this;
  //   if (!loadmore) {
  //     ref.setState({ totalcount: null });
  //   }

  //   var request = doRequest(
  //     "cms-operations2",
  //     {
  //       action: "list-posts",
  //       module: "harghartiranga",
  //       model: "post",
  //       lastEvaluatedKey: ref.state.lastEvaluatedKeydis,
  //       data: {
  //         direction: "desc",
  //         status: "disabled",
  //         limit: 1000,
  //       },
  //     },
  //     true
  //   );
  //   request.addEventListener("load", function () {
  //     var response = this.responseText;
  //     //   try {
  //     response = JSON.parse(response);
  //     if (response._resultflag && response._resultflag == 1) {
  //       console.log(ref.state.items);
  //       console.log(response.Count);
  //       let loadMoreItems = loadmore
  //         ? [...ref.state.disitems, ...response.items]
  //         : response.items;
  //       console.log(loadMoreItems);

  //       ref.setState(
  //         {
  //           response: response,
  //           totalcount:
  //             parseInt(loadMoreItems.length) + parseInt(ref.state.itemscount),
  //           disitems: loadMoreItems,
  //           lastEvaluatedKeydis: response.lastEvaluatedKey,
  //           postCount: response.countdata.Count,
  //           // status: status,
  //         },
  //         () => {
  //           $("#loader").css({ display: "none" });

  //           if (response.items.length > 999) {
  //             // ref.setState({
  //             //   loadMoreDisplay: true,
  //             // });
  //             if (response.lastEvaluatedKey) {
  //               ref.getPostsdis("", true);
  //             }
  //           } else {
  //             // ref.setState({
  //             //   loadMoreDisplay: false,
  //             // });
  //           }
  //         }
  //       );
  //     }
  //     //   } catch (ex) {}
  //   });
  // };

  // getPosts = (status, loadmore, dis) => {
  //   $("#loader").css({ display: "block" });
  //   var ref = this;
  //   if (!loadmore) {
  //     ref.setState({ itemscount: null });
  //   }

  //   var request = doRequest(
  //     "cms-operations2",
  //     {
  //       action: "list-posts",
  //       module: "harghartiranga",
  //       model: "post",
  //       lastEvaluatedKey: ref.state.lastEvaluatedKey,
  //       data: {
  //         // direction: "desc",
  //         status: "enabled",
  //         limit: 1000,
  //       },
  //     },
  //     true
  //   );
  //   request.addEventListener("load", function () {
  //     var response = this.responseText;
  //     //   try {
  //     response = JSON.parse(response);
  //     if (response._resultflag && response._resultflag == 1) {
  //       console.log(ref.state.items);
  //       console.log(response.Count);
  //       let loadMoreItems = loadmore
  //         ? [...ref.state.items, ...response.items]
  //         : response.items;
  //       console.log(loadMoreItems);

  //       ref.setState(
  //         {
  //           response: response,
  //           itemscount: loadMoreItems.length,
  //           items: loadMoreItems,
  //           lastEvaluatedKey: response.lastEvaluatedKey,
  //           postCount: response.countdata.Count,

  //           // status: status,
  //         },
  //         () => {
  //           if (!response.lastEvaluatedKey) {
  //             ref.getPostsdis();
  //           }
  //           // $("#loader").css({ display: "none" });

  //           if (response.items.length > 499) {
  //             // ref.setState({
  //             //   loadMoreDisplay: true,
  //             // });
  //             if (response.lastEvaluatedKey) {
  //               ref.getPosts("", true);
  //             }
  //           } else {
  //             // ref.setState({
  //             //   loadMoreDisplay: false,
  //             // });
  //           }
  //         }
  //       );
  //     }
  //     //   } catch (ex) {}
  //   });
  // };

  getSubmitDataDisabled = async (status, loadmore) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ totalcount: null });
    }
    console.log("submit button clicked");
    let newStartDate = this.state.startDate.split("-");
    newStartDate[2] = newStartDate[2] - 1;

    // console.log(
    //   "start date is ",
    //   newStartDate.join("-") + "T18:32:40.191Z",
    //   " and end date is ",
    //   this.state.endDate + "T18:28:40.191Z"
    // );

    var request = doRequest(
      "cms-operations2",
      {
        action: "search-by-date",
        module: "harghartiranga",
        model: "post",
        data: {
          start:
            moment(this.state.startDate)
              .subtract(1, "days")
              .format("YYYY-MM-DD") + "T18:32:40.191Z",
          end: this.state.endDate + "T18:32:40.191Z",
          status: "0",
          limit: 1000,
        },
        lastEvaluatedKey: ref.state.lastEvaluatedKeydis,
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      //   try {
      response = JSON.parse(response);
      if (response._resultflag && response._resultflag == 1) {
        console.log('item-211',ref.state.items);
        console.log('count-212',response.countdata.Count);
        let loadMoreItems = loadmore
          ? [...ref.state.disitems, ...response.items]
          : response.items;
        console.log('load-216',loadMoreItems);

        ref.setState(
          {
            response: response,
            totalcount:
              parseInt(loadMoreItems.length) + parseInt(ref.state.itemscount),
            disitems: loadMoreItems,
            lastEvaluatedKeydis: response.lastEvaluatedKey,
            postCount: response.countdata.Count,
            // status: status,
          },
          () => {
            $("#loader").css({ display: "none" });

            if (response.items.length > 999) {
              // ref.setState({
              //   loadMoreDisplay: true,
              // });
              if (response.lastEvaluatedKey) {
                ref.getSubmitDataDisabled("", true);
              }
            } else {
              // ref.setState({
              //   loadMoreDisplay: false,
              // });
            }
          }
        );
      }
      //   } catch (ex) {}
    });
  };
  getSubmitDataEnabled = async (status, loadmore) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!this.state.startDate || !this.state.endDate) {
      alert("Please select both dates");
      $("#loader").css({ display: "none" });
      return false;
    }
    if (this.state.startDate > this.state.endDate) {
      alert("Start date should be smaller than end date");
      $("#loader").css({ display: "none" });
      return false;
    }

    if (!loadmore) {
      ref.setState({ totalcount: null });
    }

    var request = doRequest(
      "cms-operations2",
      {
        action: "search-by-date",
        module: "harghartiranga",
        model: "post",
        data: {
          start:
            moment(this.state.startDate)
              .subtract(1, "days")
              .format("YYYY-MM-DD") + "T18:32:40.191Z",
          end: this.state.endDate + "T18:32:40.191Z",
          status: "1",
          limit: 1000,
        },
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      //   try {
      response = JSON.parse(response);
      if (response._resultflag && response._resultflag == 1) {
        console.log('item-291',ref.state.items);
        console.log('count-292',response.countdata.Count);
        let loadMoreItems = loadmore
          ? [...ref.state.items, ...response.items]
          : response.items;
        console.log('load-296',loadMoreItems);

        ref.setState(
          {
            response: response,
            itemscount: loadMoreItems.length,
            items: loadMoreItems,
            lastEvaluatedKey: response.lastEvaluatedKey,
            postCount: response.countdata.Count,
            // status: status,
          },
          () => {
            if (!response.lastEvaluatedKey) {
              console.log('kuch mila-309');
              ref.getSubmitDataDisabled();
            }
            // $("#loader").css({ display: "none" });

            if (response.items.length > 499) {
              // ref.setState({
              //   loadMoreDisplay: true,
              // });
              if (response.lastEvaluatedKey) {
                ref.getSubmitDataEnabled("", true);
              }
            } else {
              // ref.setState({
              //   loadMoreDisplay: false,
              // });
            }
          }
        );
      }
      //   } catch (ex) {}
    });
  };

  submitFunc = async () => {
    let ref = this;
    ref.setState(
      {
        response: null,
        itemscount: "",
        items: [],
        lastEvaluatedKey: "",
        postCount: 0,
        totalcount: null,
        disitems: [],
        lastEvaluatedKeydis: "",
      },
      () => {
        this.getSubmitDataEnabled();
      }
    );
  };

  render() {
    // var bread = "Aa Gujarat Ame Banaavyu Che / Moderation (Disabled Posts)";
    // var pagelink = "/gujaratelection/moderation";
    // if (this.props.match.params.status == "disabled") {
    //   bread = "Aa Gujarat Ame Banaavyu Che/ Moderation (Disabled Posts)";
    //   pagelink += "/disabled";
    // } else if (this.props.match.params.status == "enabled") {
    //   bread = "Aa Gujarat Ame Banaavyu Che/ Moderation (enabled Posts)";
    //   pagelink += "/enabled";
    // } else {
    //   bread = "Aa Gujarat Ame Banaavyu Che/ Moderation (Disabled Posts)";
    //   pagelink += "/disabled";
    // }
    // var items = this.state.items;
    // var links = [
    //   {
    //     link: "/gujaratelection/moderation/disabled",
    //     name: "View Disabled Posts",
    //   },
    //   {
    //     link: "/gujaratelection/moderation/enabled",
    //     name: "View Active Posts",
    //   },
    // ];

    return (
      <div>
        <PageTitle
          title="#Aa Gujarat Ame Banaavyu Che"
          bread={""}
          links={[]}
          Count={0}
          counttype={
            this.state.status == "enabled"
              ? "Active "
              : this.state.status == "disabled"
              ? "Inactive "
              : ""
          }
        />
        <div className="row row_date_div">
          <div className="col-md-2">
            <label htmlFor="startDate">Start Date</label>
            {/* <DatePicker
                selected={this.state.startDate}
                onChange={(date) => this.setState({ startDate: date })}
                dateFormat="DD/MM/YYYY"
                placeholderText="Start date"
              /> */}
            <input
              id="startDate"
              className="form-control"
              type={"date"}
              defaultValue={this.state.startDate}
              onChange={(e) => this.setState({ startDate: e.target.value })}
            />
          </div>
          <div className="col-md-2">
            <label htmlFor="">End Date</label>
            {/* <DatePicker
                selected={this.state.endDate}
                onChange={(date) => this.setState({ endDate: date })}
                dateFormat="DD/MM/YYYY"
                placeholderText="End date"
              /> */}
            <input
              id="endDate"
              type={"date"}
              className="form-control"
              defaultValue={this.state.endDate}
              onChange={(e) => this.setState({ endDate: e.target.value })}
            />
          </div>
          <div className="col-md-2">
            <button
              onClick={() => this.submitFunc()}
              className="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </div>
        <div style={{ margin: "20px" }}>
          <div style={{ display: "flex" }}>
            {" "}
            <h4>Total Cards :</h4>{" "}
            <span style={{ margin: "5px 5px 5px 20px", fontWeight: "900" }}>
              {this.state.totalcount}
            </span>
          </div>
          <div style={{ display: "flex" }}>
            {" "}
            <h4>Gallery Cards :</h4>{" "}
            <span style={{ margin: "5px 5px 5px 20px", fontWeight: "900" }}>
              {this.state.itemscount}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Count;



// WEBPACK FOOTER //
// ./src/Components/GujaratElection/Count.jsx